import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { pageTitle } from '../../../store/softSlice';
import YearlyBudgetFormView from '../../../components/account/create/year_budget/YearlyBudgetFormView';
import AppURL from '../../../widgets/AppURL';
import { fetchDataFromApi } from '../../../widgets/api';
import { Grid } from '@mui/material';
import YearlyBudgetListView from '../../../components/account/create/year_budget/YearlyBudgetListView';

const YearlyBudgetCreateListView = ({ PageTitle, setIconsButton }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(pageTitle({ title: PageTitle }));
    document.title = `${PageTitle}`;
    setIconsButton(null);
  }, []);
  const [onGeneralLedger, setOnGeneralLedger] = useState([]);
  const TransactionOptionsView = async () => {
    try {
      await fetchDataFromApi(AppURL.AccountsURL + "account-transaction-general-ledg-list-view/").then((res) => {
        setOnGeneralLedger(res);
      });
    } catch (error) {
      console.log(error);
    }
  }
  useEffect(() => {
    TransactionOptionsView();
  }, []);

  const [onAcaListData, setOnAcaListData] = useState([]);
  const url = AppURL.AccountsURL + "account-yearly-budget-create-list-view/";
  const [onUpdateURL, setOnUpdateURL] = useState("");
  const fetchAcademicsListView = async (urls) => {
    setOnUpdateURL(urls);
    try {
      await fetchDataFromApi(urls).then((res) => {
        setOnAcaListData(res);
      });
    } catch (error) {
      console.log(error);
    }
  }
  const FetchData = async () => {
    await fetchAcademicsListView(url);
  }

  useEffect(() => {
    FetchData();
  }, []);
  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xl={4} lg={4} sm={12} xs={12} md={6}>
          <YearlyBudgetFormView onGeneralLedger={onGeneralLedger} FetchData={FetchData} />
        </Grid>
        <Grid item xl={8} lg={8} sm={12} xs={12} md={6}>
          <YearlyBudgetListView onAcaListData={onAcaListData} fetchAcademicsListView={fetchAcademicsListView} />
        </Grid>
      </Grid>
    </div>
  )
}

export default YearlyBudgetCreateListView
